﻿import { IJsTreeOptions, JsTreeConfig } from "./treeconfig";
import $ from 'jquery';
import "../../utilities/extensions";

declare global {
  interface JQuery {
    treeinput: (option) => any;
  }
}

export class TreeInput {
  static get wireup(): string {
    return '[data-treeinput]';
  }

  private DEFAULTS: ITreeInputOptions = {
    treeOptions: { 'nodes': new Array() },
    inputName: null
  };

  private $input: JQuery;
  constructor(private $jsTree, private options?: ITreeInputOptions) {
    this.setOptions();
    this.findInput();
    this.validate();
    this.createTree();
    this.wireupEvents();
  }

  public setSelectedValues(): void {
    let checkedIds = this.$jsTree.jstree('get_selected', true)
      .filter(n => n.children.length == 0)
      .map(n => n.id)
      .join();
    this.$input.val(checkedIds);
  }

  private setOptions(): void {
    this.options = $.extend({}, this.DEFAULTS, this.$jsTree.data(), this.options);
  }

  private findInput(): void {
    this.$input = $('name'.asAttrSelector(this.options.inputName));
  }

  private validate(): void {
    if (this.$input.length == 0)
      throw Error("$input could not be found with name: " + this.options.inputName);
    if (this.options.treeOptions === undefined)
      throw Error("TreeOptions are required");
  }

  private createTree(): void {
    let config = new JsTreeConfig(this.options.treeOptions);
    this.$jsTree.append($('<p class="spacer-all">').html("Loading..."))
      .jstree(config.toJson());
    this.$jsTree.addClass('treeinput');
  }

  private wireupEvents() {
    this.$jsTree.closest('form').on('click.rustig', '[type="submit"]', () => this.setSelectedValues());
  }
}

export interface ITreeInputOptions {
  treeOptions: IJsTreeOptions;
  inputName: string;
}

(function ($) {
  function Plugin(option) {
    return this.each(function () {
      let $this = $(this);
      let data = $this.data('rustig.treeinput');

      if (!data) {
        data = new TreeInput($this);
        $this.data('rustig.treeinput', data);
      }
      if (typeof option == 'string') {
        data[option]();
      }
    });
  }
$.fn.treeinput = Plugin;

})($);